import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tertiaryColor,
  bodyColor,
  titleColor,
} from 'helpers/colors';

export default class Theme extends React.Component {
  render() {
    const { children } = this.props;

    const theme = createMuiTheme({
      palette: {
        type: 'light',
        primary: {
          main: '#b57eb5',
          light: primaryColor,
        },
        secondary: {
          main: '#b57eb5',
          contrastText: '#fff',
        },
        tertiary: {
          main: tertiaryColor,
        },
        text: {
          primary: '#1D2021',
          secondary: secondaryColor,
          light,
          dark,
        },
        action: {
          disabled: disabledColor,
        },
        background: {
          default: backgroundColor,
          // input: primaryColor,
          // paper: '#fff',
        },
        footer: {
          color: '#fff',
          linkColor: '#fff',
          background: '#464340'
        }
      },
      typography: {
        fontFamily: ['Montserrat, Helvetica, Arial, sans-serif'].join(','),
        useNextVariants: true,
        h1: {
          fontFamily: 'Catamaran, Montserrat, Arial',
          color: '#464340',
          // fontWeight: 'bold',
          fontSize: '5rem',
          marginBottom: 30,
          width: '100%',
          textAlign: 'center',
        },
        h2: {
          color: '#464340',
          fontFamily: 'Catamaran, Arial',
          textAlign: 'center',
          fontSize: '3.5rem',
          width: '100%',
        },
        h3: {
        //   // color: primaryColor,
          fontSize: '2rem',
        //   fontWeight: 400,
          marginBottom: 30,
        //   paddingBottom: 10,
        //   paddingTop: 10,
        //   textTransform: 'uppercase',
        //   // border: primaryColor + ' 1px solid',
        //   textAlign: 'left',
        },
        // h4: {
        //   // color: primaryColor,
        //   color: 'inherit',
        //   fontSize: '1.4rem',
        //   fontWeight: 'normal',
        //   textTransform: 'uppercase',
        //   marginBottom: 24,
        // },
        // h5: {
        //   // color: primaryColor,
        //   color: 'inherit',
        //   fontSize: '1.2rem',
        //   // fontWeight: 'bold',
        //   marginTop: '24px',
        //   position: 'relative',
        // },
        // h6: {
        //   // color: primaryColor,
        //   fontSize: '1.1rem',
        //   // paddingBottom: 10,
        //   // paddingTop: 10,
        //   // paddingLeft: 16,
        //   // paddingRight: 16,
        //   // border: primaryColor + ' 1px solid',
        //   textAlign: 'left',
        //   // marginBottom: 32
        // },
        body1: {
          fontSize: '1rem',
          color: 'inherit',
          // color: primaryColor,
        },
        body2: {
          fontSize: '1rem',
          // color: '#1D2021',
        },
        subtitle1: {
          // color: primaryColor,
          fontSize: '1rem',
        },
        subtitle2: { color: secondaryColor, fontSize: '1rem' },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
      //   MuiButton: {
      //     root: {
      //       color: primaryColor,
      //       backgroundColor: secondaryColor,
      //       '&:hover': {
      //         backgroundColor: primaryColor,
      //         color: secondaryColor,
      //       },
      //       '&.MuiButton-outlinedSecondary': {
      //         backgroundColor: light,
      //         '&:hover': {
      //           color: light,
      //           backgroundColor: secondaryColor,
      //         },
      //       },
      //       '&.MuiButton-containedSecondary': {
      //         // border: '1px solid transparent',
      //         // '&:hover': {
      //         //   border: '1px solid rgba(0, 102, 157, 0.5)',
      //         //   color: secondaryColor,
      //         //   backgroundColor: light,
      //         // },
      //         color: '#fff',
      //         fontWeight: 'bold',
      //         backgroundColor: primaryColor,
      //         textTransform: 'none',
      //         opacity: 0.8,
      //         '&:hover': {
      //           color: primaryColor,
      //           backgroundColor: '#fff',
      //         },
      //       },
      //       '&$disabled': {
      //         color: '#fff'
      //       }
      //       // '&.MuiButton-sizeLarge': {
      //       //   padding: '8px 50px',
      //       // },
      //     },
      //     textSecondary: {
      //       color: primaryColor
      //     },
      //     textSizeSmall: {
      //       color: primaryColor
      //     },
      //     outlinedPrimary: {
      //       // backgroundColor: primaryColor,
      //       backgroundColor: secondaryColor,
      //       fontWeight: 'bold',
      //       color: '#fff',
      //       '&:hover': {
      //         // color: primaryColor,
      //         color: secondaryColor,
      //         backgroundColor: '#fff',
      //       },
      //       '&.Mui-disabled': {
      //         backgroundColor: '#fff',
      //         opacity: 0.7,
      //       },
      //     },
      //   },
      //   MuiFormLabel: {
      //     root: {
      //       // color: '#fff',
      //       '&.Mui-focused': {
      //         color: primaryColor,
      //       },
      //     },
      //   },
      //   MuiFormHelperText: {
      //     root: {
      //       color: primaryColor,
      //     },
      //   },
      //   'MuiStepper-root': {
      //     padding: 0,
      //   },
      //   MuiStep: {
      //     root: {
      //       '& > .MuiStepConnector-root': {
      //         display: 'none',
      //       },
      //     },
      //   },
      //   MuiMenuItem: {
      //     root: {
      //       // color: '#fff',
      //     },
      //   },
      //   MuiAlert: {
      //     standardSuccess: {
      //       // color: '#fff',
      //       fontWeight: 'bold'
      //     }
      //   }
      },
    });

    // theme.overrides.MuiButton.root.boxShadow = theme.shadows[2];
    // theme.typography.h1 = {
    //   ...theme.typography.h1,
    //   marginTop: theme.spacing(2),
    //   marginBottom: t heme.spacing(5),
    //   paddingLeft: theme.spacing(2),
    //   paddingRight: theme.spacing(2),
    //   // boxShadow: theme.shadows[3],
    //   [theme.breakpoints.down('md')]: {
    //     fontSize: '1.4rem',
    //   },
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: '1.3rem',
    //   },
    //   [theme.breakpoints.down('xs')]: {
    //     fontSize: '1.1rem',
    //   },
    //   // [theme.breakpoints.up('xs')]: {
    // //     fontSize: '2.4rem',
    // //   },
    // //   [theme.breakpoints.up('sm')]: {
    // //     fontSize: '3.5rem',
    // //   },
    // //   [theme.breakpoints.up('md')]: {
    // //     fontSize: '4rem',
    // //   },
    // //   [theme.breakpoints.up('lg')]: {
    // //     fontSize: '5rem',
    // //   },
    // //   [theme.breakpoints.up('xl')]: {
    // //     fontSize: '5.5rem',
    // //   },
    // };

    // theme.typography.h2 = {
    //   ...theme.typography.h2,
    //   // [theme.breakpoints.up('xs')]: {
    //   //   fontSize: '1.5rem',
    //   //   textAlign: 'center',
    //   // },
    //   // [theme.breakpoints.up('sm')]: {
    //   //   fontSize: '2.2rem',
    //   // },
    //   // [theme.breakpoints.up('md')]: {
    //   //   fontSize: '2.6rem',
    //   //   textAlign: 'left',
    //   //   lineHeight: '4.8rem',
    //   // },
    //   // [theme.breakpoints.up('lg')]: {
    //   //   fontSize: '3rem',
    //   //   lineHeight: '5.2rem',
    //   // },
    //   // [theme.breakpoints.up('xl')]: {
    //   //   fontSize: '3.5rem',
    //   //   lineHeight: '5.8rem',
    //   // },
    // };
    //
    // theme.overrides['MuiContainer'] = {
    //   fixed: {
    //     [theme.breakpoints.down('lg')]: {
    //       maxWidth: '100%',
    //     },
    //   },
    // };

    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx